import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <PageSection labelledBy="faq-title" className="bg-slate-950" data-id="element-90" data-mp="urko47xxef4y">
      <SectionHeading id="faq-title" title="Preguntas frecuentes" data-id="element-91" data-mp="729lekx0mao6" />
      <ul className="mt-8 space-y-3" data-id="element-92" data-mp="22dikp020pa7">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        const panelId = `faq-panel-${i}`;
        return <li key={f.q} className={`rounded-xl border bg-zinc-900 transition-colors duration-200 ${isOpen ? 'border-cyan-500/60' : 'border-zinc-800'}`} data-id="element-93" data-mp="h0peuujilw0u" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 rounded-xl px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50" data-id="element-94" data-mp="1se1k99uxamp4">
                <span className="font-display text-sm font-extrabold uppercase leading-snug text-white md:text-base" data-id="element-95" data-mp="msk77ehev733">{f.q}</span>
                <PlusIcon className={`h-5 w-5 shrink-0 text-cyan-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-96" data-mp="rsyh722kor3r" />
              </button>
              <AnimatePresence initial={false} data-id="element-97" data-mp="3v9f0c28epd3z">
                {isOpen && <motion.div id={panelId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-98" data-mp="3v6st63pfgzma">
                    <div className="space-y-1.5 px-5 pb-5 text-base leading-relaxed text-zinc-300" data-id="element-99" data-mp="3cgbbqva1pqg8">
                      {f.a.map(line => <p key={line} data-id="element-100" data-mp="nozfx6fqq4wk">{line}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </PageSection>;
}